import { BookOpenText, MessageSquareMore } from "lucide-react";
import Discord from "@/components/icons/discord";
import { LIBUM_DISCORD_URL, LIBUM_FEEDBACK_URL } from "@/lib/constants";

// Shared by authenticated Portal and public docs; no account data dependencies.
export const resourceNavigation = [
  { title: "Docs", url: "/docs", icon: BookOpenText },
  { title: "Libum Community", url: LIBUM_DISCORD_URL, icon: Discord },
  { title: "Feedback", url: LIBUM_FEEDBACK_URL, icon: MessageSquareMore },
];
